import { BillingClient } from 'client/client';

// Adapter exposing the trio of gRPC calls expected by `executeCheckoutPlan`
// from the marketing lib. Userid is fixed at construction time so the
// executor doesn't need to know about auth context.

export function makeGrpcAdapter(client: BillingClient, userId: string) {
  return {
    modifySubscription: (req: any) =>
      client.modifySubscriptions({
        userId,
        subscriptionId: req.subscription_id,
        quantity: req.quantity,
        subscriptionItemId: req.subscription_item_id || '',
        coupon: req.coupon || '',
        checkoutRef: req.checkout_ref || ''
      } as any),

    addSubscriptionItem: (req: any) =>
      client.addSubscriptionItem({
        userId,
        subscriptionId: req.subscription_id,
        priceId: req.price_id,
        quantity: req.quantity,
        coupon: req.coupon || '',
        checkoutRef: req.checkout_ref || ''
      } as any),

    // Pairs with addSubscriptionItem to perform a SKU swap (e.g. futures
    // pay-as-you-go → unlimited) in executeCheckoutPlan — ModifySubscription
    // has no price field, so a price change is add(new)+remove(old).
    removeSubscriptionItem: (req: any) =>
      client.removeSubscriptionItem({
        userId,
        subscriptionId: req.subscription_id,
        subscriptionItemId: req.subscription_item_id || ''
      } as any),

    createSubscription: async (payload: any) => {
      try {
        const items = (payload.items || []).map((it: any) => ({
          priceId: it.price_id,
          quantity: it.quantity
        }));
        // gRPC AlreadyExists (code 6) is treated as no-op by the executor
        return await client.createSubscription({
          userId,
          // First item also fills the legacy single-price fields so older
          // billing-manager versions remain happy.
          priceId: items[0]?.priceId || '',
          quantity: items[0]?.quantity || 0,
          itemsList: items,
          useTrial: Boolean(payload.use_trial),
          toltReferral: payload.tolt_referral || '',
          coupon: payload.coupon || '',
          checkoutRef: payload.checkout_ref || '',
          isDedi: Boolean(payload.is_dedi)
        } as any);
      } catch (err: any) {
        const code = err?.code;
        const msg = String(err?.details || err?.message || '');
        if (code === 6 || /already exists/i.test(msg)) {
          return { skipped: true };
        }
        throw err;
      }
    }
  };
}
